// @core/api/endpoints/team/list_team_users_by_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamUsersByRoleResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List users with specific role
 * Returns all team members who have been assigned a specific role. Useful for role-based member management.
 */
export async function ListTeamUsersByRole(
  team_id: string,
  role_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamUsersByRoleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id/users`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.get<ListTeamUsersByRoleResponse>(requestPath, { ...requestOptions, params });
}
